import { Routes } from '@angular/router';
import { staffAuthChildrenGuard, staffAuthGuard } from './staff/guards/staff-auth.guard';
import { clientAuthGuard } from './client/guards/client-auth.guard';
import { minDelayResolver } from './resolvers/min-delay.resolver';
import { getUnauthenticatedInvoiceDataResolver } from './resolvers/get-unauthenticated-invoice-data.resolver';
import { getStaffAccountFromImpersonationResolver } from './client/resolvers/get-staff-account-from-impersonation.resolver';
import { getCurrentStaffAccountResolver } from './resolvers/get-current-staff-account.resolver';
import { getCurrentClientAccountResolver } from './resolvers/get-current-client-account.resolver';
import { loadClientDashboardRoleGuard } from './client/guards/load-client-dashboard-role.guard';

export const routes: Routes = [
  {
    path: "",
    loadComponent: () => import("./login/login.component").then(mod => mod.LoginComponent),
  },
  {
    path: "account/reset-password/:token",
    loadComponent: () => import("./reset-password/reset-password.component").then(mod => mod.ResetPasswordComponent),
  },
  {
    path: "auth/staff/success",
    loadComponent: () => import("./staff/auth/success/success.component").then(mod => mod.StaffLoginSuccessComponent),
  },
  {
    path: "auth/staff/logout",
    loadComponent: () => import("./staff/auth/logout/staff-logout.component").then(mod => mod.StaffLogoutComponent),
    canActivate: [staffAuthGuard]
  },
  {
    path: "auth/client/success",
    loadComponent: () => import("./client/auth/success/success.component").then(mod => mod.ClientLoginSuccessComponent),
  },
  {
    path: "auth/client/logout",
    loadComponent: () => import("./client/auth/logout/logout.component").then(mod => mod.LogoutComponent),
  },
  {
    path: "staff-login",
    loadComponent: () => import("./staff/force-login/force-login.component").then(mod => mod.ForceLoginComponent),
  },
  {
    path: "staff",
    loadComponent: () => import("./staff/staff.component").then(mod => mod.StaffComponent),
    loadChildren: () => import("./app.routes.staff").then(mod => mod.staffRoutes),
    canActivateChild: [staffAuthChildrenGuard]
  },
  {
    path: "client",
    loadComponent: () => import("./client/client.component").then(mod => mod.ClientComponent),
    loadChildren: () => import("./app.routes.client").then(mod => mod.staffRoutes),
    canActivate: [clientAuthGuard, loadClientDashboardRoleGuard],
    resolve: {
      staffAccountFromImpersonation: getStaffAccountFromImpersonationResolver
    }
  },
  {
    path: "no-auth",
    children: [
      {
        path: "invoices/:invoiceId/:invoiceUUID",
        loadComponent: () => import("./client/no-auth/invoices/unauthenticated-view-invoice/unauthenticated-view-invoice.component").then(mod => mod.UnauthenticatedViewInvoiceComponent),
        resolve: {
          minDelayResolver: minDelayResolver,
          invoiceData: getUnauthenticatedInvoiceDataResolver
        }
      },
      {
        path: "quotes/:quoteId/:quoteUUID/accept",
        loadComponent: () => import("./client/no-auth/quotes/accept-quote/accept-quote.component").then(mod => mod.AcceptQuoteComponent),
        resolve: {
          minDelayResolver: minDelayResolver
        }
      },
      {
        path: "quotes/:quoteId/:quoteUUID/reject",
        loadComponent: () => import("./client/no-auth/quotes/reject-quote/reject-quote.component").then(mod => mod.RejectQuoteComponent),
        resolve: {
          minDelayResolver: minDelayResolver
        }
      },
    ]
  },
  {
    path: "error-pages/404",
    loadComponent: () => import("./error-pages/not-found/not-found.component").then(mod => mod.NotFoundComponent),
    resolve: {
      clientAccount: getCurrentClientAccountResolver,
      staffAccount: getCurrentStaffAccountResolver
    }
  },
  {
    path: "**",
    loadComponent: () => import("./error-pages/not-found/not-found.component").then(mod => mod.NotFoundComponent),
    resolve: {
      clientAccount: getCurrentClientAccountResolver,
      staffAccount: getCurrentStaffAccountResolver
    }
  }
];
